// Import JS used on multiple pages
import Assistant from "src/javascripts/components/Assistant";
import CardList from "src/javascripts/components/CardList";
import Collapsible from "src/javascripts/components/utilities/Collapsible";
import CollapseCard from "src/javascripts/components/utilities/CollapseCard";
import CollapsibleCardLists from "src/javascripts/components/utilities/CollapsibleCardLists";
import CopyUrl from "src/javascripts/components/utilities/CopyUrl";
import Dashboards from "src/javascripts/components/Dashboards";
import DashboardSections from "src/javascripts/components/DashboardSections";
import Table from "src/javascripts/components/Table";
import DocUploadPicker from "src/javascripts/components/forms/DocUploadPicker";
import FilePicker from "src/javascripts/components/forms/FilePicker";
import Filter from "src/javascripts/components/Filter";
import Focus from "src/javascripts/components/forms/Focus";
import FocusSearchForm from "src/javascripts/components/forms/FocusSearchForm";
import EmailChipsInput from "src/javascripts/components/forms/EmailChipsInput";
import NavbarNotifications from "src/javascripts/components/notifications/NavbarNotifications";
import PageAction from "src/javascripts/components/PageAction";
import NavBorder from "src/javascripts/components/nav/NavBorder";
import MasterSearchTypeahead from "src/javascripts/components/typeaheads/MasterSearchTypeahead";
import SetTimeZone from "src/javascripts/components/utilities/SetTimeZone";
import ScrollToTag from "src/javascripts/components/nav/ScrollToTag";
import ShowMoreButton from "src/javascripts/components/lists/ShowMoreButton";
import StickySidebar from "src/javascripts/components/nav/StickySidebar";
import SummernoteDefault from "src/javascripts/components/SummernoteDefault";
import ToastFlash from "src/javascripts/components/alerts/ToastFlash";
import TooltipInit from "src/javascripts/components/utilities/TooltipInit";
import NumberDisplay from "src/javascripts/components/utilities/NumberDisplay";
import TurboCustomActions from "src/javascripts/components/TurboCustomActions";
import Imports from "src/javascripts/components/forms/Import";
import PasswordVisibility from "src/javascripts/components/forms/PasswordVisibility";
import copyWidgetCode from "src/javascripts/components/widget";

import {
  genericDisplayTemplate,
  noResultsTemplate,
  logoTemplate,
} from "src/javascripts/components/typeaheads/TypeaheadTemplates";
import Typeahead from "src/javascripts/components/Typeahead";
import ManualListTypeahead from "src/javascripts/components/typeaheads/ManualListTypeahead";

// Accounts pages
import AccountsNew from "src/javascripts/pages/accounts/AccountsNew";
import AccountsEdit from "src/javascripts/pages/accounts/AccountsEdit";
import AccountsSetup from "src/javascripts/pages/accounts/AccountsSetup";
import AccountsFeaturesIndex from "src/javascripts/pages/accounts/features/AccountsFeaturesIndex";
import AccountsFrameworksIndex from "src/javascripts/pages/accounts/frameworks/AccountsFrameworksIndex";
import AccountsImagesIndex from "src/javascripts/pages/accounts/images/AccountsImagesIndex";
import AccountsManagedFundsEdit from "src/javascripts/pages/accounts/managed_funds/AccountsManagedFundsEdit";
import AccountsMembershipsDashboardsIndex from "src/javascripts/pages/accounts/memberships/dashboards/AccountsMembershipsDashboardsIndex";
import AccountsMembershipsSurveysIndex from "src/javascripts/pages/accounts/memberships/surveys/AccountsMembershipsSurveysIndex";
import AccountsRestrictedAssetsIndex from "src/javascripts/pages/accounts/restricted_assets/AccountsRestrictedAssetsIndex";
import AccountsStripeInvoicesBilling from "src/javascripts/pages/accounts/stripe/invoices/AccountsStripeInvoicesBilling";
import AccountsStripeSubscriptionsEdit from "src/javascripts/pages/accounts/stripe/subscriptions/AccountsStripeSubscriptionsEdit";
import AccountsStripeSubscriptionsNew from "src/javascripts/pages/accounts/stripe/subscriptions/AccountsStripeSubscriptionsNew";
import AccountsSurveyOptionsEdit from 'src/javascripts/pages/accounts/survey_options/AccountsSurveyOptionsEdit';

// Admin pages
import Admin from "src/javascripts/pages/Admin";
import AdminDataFrameworksMetricWeightsEdit from "src/javascripts/pages/admin/data/frameworks/metric_weights/AdminDataFrameworksMetricWeightsEdit";

// API
import ApiDocsIndex from "src/javascripts/pages/api/docs/ApiDocsIndex";
import ApiKeysIndex from "src/javascripts/pages/api/keys/ApiKeysIndex";
import ApiLogsIndex from "src/javascripts/pages/api/logs/ApiLogsIndex";

// Assessment pages
import AssessmentsPreferences from "src/javascripts/pages/assessments/AssessmentsPreferences";
import AssessmentsEditPillars from "src/javascripts/pages/assessments/AssessmentsEditPillars";
import AssessmentsRankPillars from "src/javascripts/pages/assessments/AssessmentsRankPillars";
import AssessmentsEditPillar from "src/javascripts/pages/assessments/AssessmentsEditPillar";
import AssessmentsQuestions from "src/javascripts/pages/assessments/AssessmentsQuestions";
import AssessmentsContactInfo from "src/javascripts/pages/assessments/AssessmentsContactInfo";
import AssessmentsScreens from "src/javascripts/pages/assessments/AssessmentsScreens";
import AssessmentsAdvocacy from "src/javascripts/pages/assessments/AssessmentsAdvocacy";

// Auth pages
import Auth from "src/javascripts/pages/Auth";

// Carbon pages
import Carbon from "src/javascripts/pages/Carbon";

// Clients
import ClientsImpactCalculatorsEdit from "src/javascripts/pages/clients/impact_calculators/ClientsImpactCalculatorsEdit";
import ClientsImpactCalculatorsShow from "src/javascripts/pages/clients/impact_calculators/ClientsImpactCalculatorsShow";
import ClientsImpactCalculatorsPublic from "src/javascripts/pages/clients/impact_calculators/ClientsImpactCalculatorsPublic";
import CalculatorForm from "./clients/impact_calculators/CalculatorForm";
import ClientsHouseholdsEdit from "src/javascripts/pages/clients/households/ClientsHouseholdsEdit";
import ClientsHouseholdsPortfoliosIndex from "src/javascripts/pages/clients/households/portfolios/ClientsHouseholdsPortfoliosIndex";
import ClientsPortfoliosIndex from "src/javascripts/pages/clients/portfolios/ClientsPortfoliosIndex";
import ClientsIndex from "src/javascripts/pages/clients/ClientsIndex";

// Dashboards
import DashboardsBenchmarksIndex from "src/javascripts/pages/dashboards/benchmarks/DashboardsBenchmarksIndex";
import DashboardsEdit from "src/javascripts/pages/dashboards/DashboardsEdit";

// Data
import DataCustomMetricScoresImportsNew from "src/javascripts/pages/data/custom_metric_scores/DataCustomMetricScoresImportsNew";
import AdminDataFrameworksPillarsEdit from "src/javascripts/pages/admin/data/frameworks/AdminDataFrameworksPillarsEdit";
import AdminDataFrameworksPillarsIndex from "src/javascripts/pages/admin/data/frameworks/AdminDataFrameworksPillarsIndex";
import AdminDataFrameworksTopicsEdit from "src/javascripts/pages/admin/data/frameworks/AdminDataFrameworksTopicsEdit";
import AdminDataFrameworksWeightsImportsNew from "src/javascripts/pages/admin/data/frameworks/AdminDataFrameworksWeightsImportsNew";
import DataCustomMetricsIndex from "src/javascripts/pages/data/custom_metrics/DataCustomMetricsIndex";

// Exports
import ExportsEdit from 'src/javascripts/pages/exports/ExportsEdit';
import ExportsSchedulesEdit from 'src/javascripts/pages/exports/schedules/ExportsSchedulesEdit';
import ExportsTemplatesColumnsEdit from 'src/javascripts/pages/exports/templates/columns/ExportsTemplatesColumnsEdit';
import ExportsTemplatesColumnsIndex from 'src/javascripts/pages/exports/templates/columns/ExportsTemplatesColumnsIndex';
import ExportsTemplatesRowFiltersIndex from 'src/javascripts/pages/exports/templates/row_filters/ExportsTemplatesRowFiltersIndex';

// Help center pages
import Help from "src/javascripts/pages/Help";

// Marketplace
import MarketplaceProductsShow from "src/javascripts/pages/marketplace/products/MarketplaceProductsShow";
import MarketplaceProductsPreview from "src/javascripts/pages/marketplace/products/MarketplaceProductsPreview";

// Monitoring pages
import MonitoringRulesEdit from "src/javascripts/pages/monitoring/rules/MonitoringRulesEdit";
import MonitoringTestsEdit from "src/javascripts/pages/monitoring/tests/MonitoringTestsEdit";
import MonitoringTestRunsIndex from "src/javascripts/pages/monitoring/test_runs/MonitoringTestRunsIndex";

// Public pages
import Public from "src/javascripts/pages/Public";

// Portfolios
import PortfoliosIndex from "src/javascripts/pages/portfolios/PortfoliosIndex";
import PortfoliosFinancialsIndex from "src/javascripts/pages/portfolios/financials/PortfoliosFinancialsIndex";
import PortfoliosInvestmentsIndex from 'src/javascripts/pages/portfolios/investments/PortfoliosInvestmentsIndex';
import PortfoliosMetricScoresIndex from "src/javascripts/pages/portfolios/metric_scores/PortfoliosMetricScoresIndex";
import PortfoliosModelsEdit from "src/javascripts/pages/portfolios/models/PortfoliosModelsEdit";
import PortfoliosModelsImportsNew from "src/javascripts/pages/portfolios/models/PortfoliosModelsImportsNew";
import PortfolioForm from "./portfolios/PortfolioForm";

// Reports pages
import ReportsNew from "src/javascripts/pages/reports/ReportsNew";
import ReportsEdit from "src/javascripts/pages/reports/ReportsEdit";
import ReportsIndex from "src/javascripts/pages/reports/ReportsIndex";
import ReportsBenchmarksIndex from "src/javascripts/pages/reports/benchmarks/ReportsBenchmarksIndex";
import ReportsSchedulesEdit from "src/javascripts/pages/reports/schedules/ReportsSchedulesEdit";

// Research pages
import Research from "src/javascripts/pages/Research";
import ResearchFundsShow from "src/javascripts/pages/research/funds/ResearchFundsShow";
import ResearchListsItemsIndex from "src/javascripts/pages/research/lists/items/ResearchListsItemsIndex";
import ResearchLocationsIndex from "src/javascripts/pages/research/locations/ResearchLocationsIndex";
import ResearchLocationsShow from "src/javascripts/pages/research/locations/ResearchLocationsShow";

// Sections
import SectionsInclusionsEdit from "src/javascripts/pages/sections/inclusions/SectionsInclusionsEdit";
import SectionsInclusionsIndex from "src/javascripts/pages/sections/inclusions/SectionsInclusionsIndex";

// Surveys
import Surveys from "src/javascripts/pages/Surveys";
import SurveysApprovalActionsNew from "src/javascripts/pages/surveys/approval_actions/SurveysApprovalActionsNew";
import SurveysApprovalRequestsEdit from "src/javascripts/pages/surveys/approval_requests/SurveysApprovalRequestsEdit";
import SurveysApprovalRequestsIndex from "src/javascripts/pages/surveys/approval_requests/SurveysApprovalRequestsIndex";
import SurveysContentsEdit from "src/javascripts/pages/surveys/contents/SurveysContentsEdit";
import SurveysContentsFormStepTwo from "src/javascripts/pages/surveys/contents/SurveysContentsFormStepTwo";
import SurveysDataIndex from "src/javascripts/pages/surveys/data/SurveysDataIndex";
import SurveysDocumentsNew from "src/javascripts/pages/surveys/documents/SurveysDocumentsNew";
import SurveysEmailsNew from "src/javascripts/pages/surveys/emails/SurveysEmailsNew";
import SurveysQuestionsEdit from "src/javascripts/pages/surveys/questions/SurveysQuestionsEdit";
import SurveysQuestionsNew from "src/javascripts/pages/surveys/questions/SurveysQuestionsNew";
import SurveysQuestionsFormStepTwo from "src/javascripts/pages/surveys/questions/SurveysQuestionsFormStepTwo";
import SurveysQuestionsFormStepThree from "src/javascripts/pages/surveys/questions/SurveysQuestionsFormStepThree";
import SurveysAccessesEdit from "src/javascripts/pages/surveys/accesses/SurveysAccessesEdit";
import SurveysAccessesIndex from "src/javascripts/pages/surveys/accesses/SurveysAccessesIndex";
import SurveysSectionsEdit from "src/javascripts/pages/surveys/sections/SurveysSectionsEdit";
import SurveysSectionsIndex from "src/javascripts/pages/surveys/sections/SurveysSectionsIndex";
import SurveysSectionsQuestionGroupsEdit from 'src/javascripts/pages/surveys/sections/question_groups/SurveysSectionsQuestionGroupsEdit';
import SurveysSectionsQuestionGroupsIndex from "src/javascripts/pages/surveys/sections/question_groups/SurveysSectionsQuestionGroupsIndex";
import SurveysTablesEdit from "src/javascripts/pages/surveys/tables/SurveysTablesEdit";
import SurveysTablesFormStepTwo from "src/javascripts/pages/surveys/tables/SurveysTablesFormStepTwo";
import SurveysShow from "src/javascripts/pages/surveys/SurveysShow";
import SurveysIndex from "src/javascripts/pages/surveys/SurveysIndex";
import SurveysEdit from "src/javascripts/pages/surveys/SurveysEdit";
import SurveysFinalize from "src/javascripts/pages/surveys/SurveysFinalize";
import SurveysMetricScoresIndex from "src/javascripts/pages/surveys/metric_scores/SurveysMetricScoresIndex";
import SurveysWorkflowsIndex from "src/javascripts/pages/surveys/workflows/SurveysWorkflowsIndex";

// Users
import UsersEdit from "src/javascripts/pages/users/UsersEdit";

// NEW COMPONENTS
import EthosButton from "../components/EthosButton-storybook/EthosButton";
import DataCircle from "../components/DataCircle-storybook/DataCircle";
import EthosProgressBar from "../components/ProgressBar-storybook/EthosProgressBar";
import { deprecationHandler } from "moment/moment";

// Create a map where keys share same names as classes
const pageClasses = {
  AccountsManagedFundsEdit,
  AccountsEdit,
  AccountsNew,
  AccountsSetup,
  AccountsRestrictedAssetsIndex,
  AccountsImagesIndex,
  AccountsFeaturesIndex,
  AccountsFrameworksIndex,
  AccountsMembershipsDashboardsIndex,
  AccountsMembershipsSurveysIndex,
  AccountsStripeInvoicesBilling,
  AccountsStripeSubscriptionsEdit,
  AccountsStripeSubscriptionsNew,
  AccountsSurveyOptionsEdit,
  AdminDataFrameworksMetricWeightsEdit,
  ApiDocsIndex,
  ApiKeysIndex,
  ApiLogsIndex,
  AssessmentsContactInfo,
  AssessmentsEditPillars,
  AssessmentsEditPillar,
  AssessmentsPreferences,
  AssessmentsQuestions,
  AssessmentsRankPillars,
  AssessmentsScreens,
  AssessmentsAdvocacy,
  ClientsImpactCalculatorsEdit,
  ClientsImpactCalculatorsPublic,
  ClientsImpactCalculatorsShow,
  ClientsIndex,
  ClientsHouseholdsEdit,
  ClientsHouseholdsPortfoliosIndex,
  ClientsPortfoliosIndex,
  DashboardsBenchmarksIndex,
  DashboardsEdit,
  DataCustomMetricScoresImportsNew,
  AdminDataFrameworksPillarsEdit,
  AdminDataFrameworksPillarsIndex,
  AdminDataFrameworksTopicsEdit,
  AdminDataFrameworksWeightsImportsNew,
  DataCustomMetricsIndex,
  ExportsEdit,
  ExportsSchedulesEdit,
  ExportsTemplatesColumnsEdit,
  ExportsTemplatesColumnsIndex,
  ExportsTemplatesRowFiltersIndex,
  PortfoliosIndex,
  PortfoliosFinancialsIndex,
  PortfoliosInvestmentsIndex,
  PortfoliosMetricScoresIndex,
  PortfoliosModelsImportsNew,
  PortfoliosModelsEdit,
  MarketplaceProductsPreview,
  MarketplaceProductsShow,
  MonitoringRulesEdit,
  MonitoringTestsEdit,
  MonitoringTestRunsIndex,
  ReportsIndex,
  ReportsEdit,
  ReportsNew,
  ReportsSchedulesEdit,
  ReportsBenchmarksIndex,
  ResearchFundsShow,
  ResearchListsItemsIndex,
  ResearchLocationsShow,
  ResearchLocationsIndex,
  SectionsInclusionsEdit,
  SectionsInclusionsIndex,
  SurveysAccessesIndex,
  SurveysAccessesEdit,
  SurveysApprovalActionsNew,
  SurveysApprovalRequestsEdit,
  SurveysApprovalRequestsIndex,
  SurveysContentsEdit,
  SurveysContentsFormStepTwo,
  SurveysDataIndex,
  SurveysDocumentsNew,
  SurveysEmailsNew,
  SurveysQuestionsEdit,
  SurveysQuestionsFormStepTwo,
  SurveysQuestionsNew,
  SurveysQuestionsFormStepThree,
  SurveysSectionsQuestionGroupsEdit, 
  SurveysSectionsQuestionGroupsIndex,
  SurveysSectionsEdit,
  SurveysSectionsIndex,
  SurveysTablesEdit,
  SurveysTablesFormStepTwo,
  SurveysEdit,
  SurveysFinalize,
  SurveysIndex,
  SurveysShow,
  SurveysMetricScoresIndex,
  SurveysWorkflowsIndex,
  UsersEdit,
  EthosButton,
  DataCircle,
  EthosProgressBar,
  CalculatorForm,
  PortfolioForm
};

// Create a map for module-wide classes
const moduleClasses = { Admin, Auth, Carbon, Help, Public, Research, Surveys };

// Set vars for listening for reloading page, maintaining scroll position if on same page
// https://stackoverflow.com/questions/39679154/how-to-persist-scrolls-with-turbo
const scrollPositions = {};
let page = $("body").data("page");
scrollPositions[page] = null;

// Init page
const Init = function () {
  // Add lastpass and chrome ignore indicators
  if ($("body").attr("data-signed-in") === "true") {
    $("input").attr("data-lpignore", "true");
  }
  $("input").attr("autocomplete", "off");

  // // Load calculator script only after the impact calculator form is present in the DOM
  if ($('#impact-calculator-form').length !== 0) {
    CalculatorForm();
  }

  if ($('#portfolio-form').length !== 0) {
    PortfolioForm();
  }

  // Show flash toast, if present on page
  if ($(".flash").length !== 0) {
    ToastFlash();
  }

  $('.copyWidgetCode').on('click', function() {
    copyWidgetCode(this);
  });

  // Expand clamped cell text in locked survey tables
  $(document).on('click', '.cell-text-toggle', function() {
    const $toggle = $(this);
    const $text = $toggle.prev('.cell-text-clamped');
    const expanded = $text.css('-webkit-line-clamp') === 'none';
    $text.css('-webkit-line-clamp', expanded ? '3' : 'none');
    $toggle.text(expanded ? 'Show more' : 'Show less');
  });

  // Show AI Assistant, if present on page
  if ($("#AssistantContainer").length !== 0) {
    Assistant();
  }

  // Enable custom Turbo Actions
  TurboCustomActions();

  // Focus forms
  Focus();

  // Set time zone
  SetTimeZone();

  // Filters
  if ($(".applyFilters").length !== 0) {
    Filter();
  }

  // Log out
  $(".log-out").click(function () {
    $(this).closest("form").find(".hidden-log-out-submit").click();
  });

  // Password visibility
  PasswordVisibility();

  if (document.querySelector('[data-email-chips]')) {
    EmailChipsInput();
  }

  // Add border to navbar on scroll
  NavBorder();

  // Top navbar if signed in
  if ($("#navTop").length !== 0) {
    NavbarNotifications();
  }

  // Top navbar if signed in
  if ($(".PageActionFilterDropdown").length !== 0) {
    PageAction();
  }

  // Imports if present
  if ($(".imports-filepicker").length !== 0) {
    Imports();
  }

  // If copy text present
  if ($(".copy-url").length !== 0) {
    CopyUrl();
  }

  // If cards list
  if ($(".cards-list").length !== 0) {
    CardList();
  }

  // If show more button
  if ($("#ShowMoreButton").length !== 0) {
    ShowMoreButton();
  }

  // If filepicker
  if ($(".filepicker").length !== 0) {
    FilePicker();
  }

  // If doc filepicker
  if ($(".docs-filepicker").length !== 0) {
    DocUploadPicker();
  }

  // If collapsible cards list
  if ($(".card-list .collapse").length !== 0) {
    CollapsibleCardLists();
  }

  // If collapse card
  if ($(".collapseCard").length !== 0) {
    CollapseCard();
  }

  // Display numbers in input fields with commas for readability
  NumberDisplay();

  // Sticky sidebar
  if ($(".sticky-sidebar").length !== 0) {
    StickySidebar();
  }

  // Dashboards
  if (
    $(".rendering-container").length !== 0 ||
    $(".dashboard-container").length !== 0
  ) {
    Dashboards();
  }
  if ($("#saveDashboardSections").length !== 0) {
    DashboardSections();
  }

  // Summernote default
  SummernoteDefault();

  if ($(".ethos-dataCircle").length !== 0) {
    $(".ethos-dataCircle").each(function () {
      if ($(this).is(":empty")) {
        const percentage = $(this).data("percentage");
        const size = $(this).data("size");
        const from_percentage = $(this).data("frompercentage");
        const show_blue = $(this).data("showblue"); // Specifically to render blue circles.(Data Sources Card)
        const custom_color = $(this).data("custom-color"); // Specifically to render other custom colors
        const stroke_width = $(this).data("stroke-width"); // Defaults to 5
        const letter_only = $(this).data("letter-only"); // Option to display letter only
        const percentage_label = $(this).data("percentage-label"); // Option to set text in center of circle

        const dataCircle = DataCircle({
          percentage,
          from_percentage,
          size,
          show_blue,
          custom_color,
          stroke_width,
          letter_only,
          percentage_label,
        });

        $(this).append(dataCircle);
      }
    });
  }

  if ($(".ethos-progress-bar").length !== 0) {
    $(".ethos-progress-bar").each(function () {
      if ($(this).is(":empty")) {
        const percentage = $(this).data("percentage");
        const percentageLabel = $(this).data("percentagelabel");
        const label = $(this).data("label");
        const showLabelText = $(this).data("showlabeltext");
        let bgColour = $(this).data("bgcolour");
        let link = $(this).data("link");

        // Set width from parent element
        const parentElement = $(this).parent();
        const width = parentElement.width();
        // const width = $(this).data("width");

        let showLabel;

        if (showLabelText === false) {
          showLabel = false;
        } else {
          showLabel = true;
        }

        const progressBar = EthosProgressBar({
          percentage,
          percentageLabel,
          label,
          showLabel,
          width,
          bgColour,
          link,
        });

        $(this).append(progressBar);
      }
    });
  }

  // Add New badge to unvisited links
  if (typeof $("body").attr("data-unvisited-features") !== "undefined") {
    let unvisitedLinks = $("body").attr("data-unvisited-features");
    if (unvisitedLinks.length !== 0) {
      unvisitedLinks = JSON.parse(unvisitedLinks);
      let template =
        "<div class='bg-a-rating position-absolute badge' style='top: 4px; right: 8px; font-size: 12px;'>NEW</div>";
      let accountUrl = $("body").attr("data-account-url");
      $.each(unvisitedLinks, function (index, link) {
        // First look for links with account url
        let href = $("a[href='/" + accountUrl + link + "']");
        if (href.length !== 0) {
          href.after(template);
        }

        // Then look for links without account url
        href = $("a[href='" + link + "']");
        if (href.length !== 0) {
          href.after(template);
        }
      });
    }
  }

  // DataTables error handling
  if ($.fn.dataTable !== undefined) {
    $.fn.dataTable.ext.errMode = function (settings, helpPage, message) {
      console.log(message);
    };
  }

  // Toggle focus for typeahead on click of search button
  // Used in multiple nav bars
  if ($(".focus-search-form").length !== 0) {
    $(".focus-search-form").click(function () {
      FocusSearchForm($(this));
    });
  }

  // Render default table if displayed and not already rendered
  if ($(".default-table-on-load").length !== 0) {
    $(".default-table-on-load").each(function () {
      let tableId = $(this).attr("id");
      let wrapperId = tableId + "_wrapper";
      if ($("#" + wrapperId).length === 0) {
        let table = new Table($("#" + tableId));
        $.when(table.render()).then((status) => table.setUp(tableId));
      }
    });
  }

  // Render default Typeahead if displayed
  if ($(".default-typeahead").length !== 0) {
    $(".default-typeahead").each(function () {
      let el = $(this);
      let api_url = el.attr("data-api-url");
      let limit = el.attr("data-limit");
      if (typeof limit === "undefined") {
        limit = 1001;
      }
      let typeahead = new Typeahead(el);
      $.when(typeahead.initializeBloodhound(api_url)).then((bloodhound) =>
        typeahead.render(bloodhound, limit),
      );
    });
  }

  // Render household typeahead if displayed (for creating new households)

  // Render manual Typeahead if displayed
  if ($(".manual-list-typeahead").length !== 0) {
    $(".manual-list-typeahead").each(function (el) {
      let id = $(this).attr("id");
      let t = new ManualListTypeahead(el);
      t.render(id);
    });
  }

  // Toggle full-window view for cards
  if ($(".toggle-full-view").length !== 0) {
    $(".toggle-full-view").click(function () {
      let $card = $(this).closest(".card");
      let $chart = $card.find(".chart").data("c3-chart");
      $card.toggleClass("full-view");
      if (typeof $chart !== "undefined") {
        setTimeout(function () {
          $chart.flush();
        }, 100);
      }
    });
  }

  // Master search topics, companies, funds
  if ($("#master_search_typeahead").length !== 0) {
    let masterSearch = new MasterSearchTypeahead("master_search_typeahead");
    $.when(masterSearch.render());

    // Focus with searchable type on click of tab
    $(".master-search-filter")
      .off()
      .click(function () {
        let searchableType = $(this).attr("data-searchable-type");
        $("#master_search_typeahead").attr(
          "data-searchable-type",
          searchableType,
        );
        $("#masterSearchResults").empty();
        $("#master_search_typeahead").blur();

        // Destroy and re-build typeahead
        $("#master_search_typeahead").typeahead("destroy");
        let masterSearch = new MasterSearchTypeahead("master_search_typeahead");
        masterSearch.render();
        $("#master_search_typeahead").focus();

        // Update active class of filter
        $(".master-search-filter").removeClass("active");
        $(this).addClass("active");
      });
  }

  // Scroll to anchor on click
  if ($(".scroll-to-anchor").length !== 0) {
    $(".scroll-to-anchor").click(function (e) {
      e.preventDefault();
      let tag = $(this).attr("data-tag");
      return ScrollToTag(tag);
    });
  }

  // Set collapsible
  if ($(".collapse-item").length !== 0) {
    Collapsible();
  }

  // Init tooltips
  TooltipInit();

  // Remove toasts once they're hidden, so they don't show up on page change
  $(".toast").on("hidden.bs.toast", function () {
    $(this).remove();
  });

  // Fix for client side validations; need to remove inputs with no name
  // Client side validations throws error otherwise
  // https://github.com/DavyJonesLocker/client_side_validations/issues/629
  window.ClientSideValidations.callbacks.form.before = function (
    form,
    callback,
  ) {
    let inputs = form.find("input:not([name])");
    inputs.each(function () {
      $(this).attr("name", "dup");
    });
  };

  // Auto-show modals
  if ($(".modal.auto-show").length !== 0) {
    // Show modal if present on page (if user signed in)
    $(".modal.auto-show")
      .on("shown.bs.modal", function () {
        // get the top of the section
        let p = $(this).find(".modal-body").attr("data-scroll-p");

        // Scroll to section if p present
        if (typeof p !== "undefined") {
          $(this).find(".modal-body").scrollTop(p);
        }
      })
      .modal({ backdrop: "static", keyboard: false });
  }

  // Set page, parent and should scroll attrs from body
  let page = $("body").data("page");
  let module = $("body").data("controller-module");
  let shouldScroll = $("body").data("should-scroll");

  // Load at scroll position, if body indicates we should
  if (typeof shouldScroll !== "undefined" && scrollPositions[page]) {
    window.scrollTo(0, scrollPositions[page]);
  }

  // Execute page class, if exists
  if (typeof pageClasses[page] !== "undefined") {
    new pageClasses[page]().render();
  }

  // Execute module class, if exists
  if (typeof moduleClasses[module] !== "undefined") {
    new moduleClasses[module]().render();
  }

  // ======STORYBOOK COMPONENTS===========

  // ethos-button-storybook
  // %div.ethos-button{data: {
  //   type: "primary",
  //   button_width: 160,
  //   button_height: 40,
  //   label: "Create Survey"
  //   }
  // }
  $(".ethos-button").each(function () {
    if ($(this).is(":empty")) {
      const type = $(this).data("type");
      const buttonWidth = $(this).data("buttonWidth");
      const buttonHeight = $(this).data("buttonHeight");
      const label = $(this).data("label");
      const clear = $(this).data("clear");

      const button = EthosButton({
        type,
        buttonWidth,
        buttonHeight,
        label,
        clear,
        onClick: () => alert("Button clicked!"),
      });

      $(this).append(button);
    }
  });
  // =====================================
};

const deferredInit = function () {
  // DataCircle-storybook
  // %div.ethos-dataCircle{data:{
  //   percentage: 98,
  //   size: 146,
  // }}

  if ($(".ethos-dataCircle").length !== 0) {
    $(".ethos-dataCircle").each(function () {
      if ($(this).is(":empty")) {
        const percentage = $(this).data("percentage");
        const size = $(this).data("size");
        const from_percentage = $(this).data("frompercentage");
        const show_blue = $(this).data("showblue"); // Specifically to render blue circles.(Data Sources Card)
        const custom_color = $(this).data("custom-color"); // Specifically to render other custom colors
        const stroke_width = $(this).data("stroke-width"); // Defaults to 5
        const letter_only = $(this).data("letter-only"); // Option to display letter only
        const percentage_label = $(this).data("percentage-label"); // Option to set text in center of circle

        const dataCircle = DataCircle({
          percentage,
          from_percentage,
          size,
          show_blue,
          custom_color,
          stroke_width,
          letter_only,
          percentage_label,
        });

        $(this).append(dataCircle);
      }
    });
  }

  if ($(".ethos-progress-bar").length !== 0) {
    $(".ethos-progress-bar").each(function () {
      if ($(this).is(":empty")) {
        const percentage = $(this).data("percentage");
        const percentageLabel = $(this).data("percentagelabel");
        const label = $(this).data("label");
        const showLabelText = $(this).data("showlabeltext");
        let bgColour = $(this).data("bgcolour");
        let link = $(this).data("link");

        // Set width from parent element
        const parentElement = $(this).parent();
        const width = parentElement.width();
        // const width = $(this).data("width");

        let showLabel;

        if (showLabelText === false) {
          showLabel = false;
        } else {
          showLabel = true;
        }

        const progressBar = EthosProgressBar({
          percentage,
          percentageLabel,
          label,
          showLabel,
          width,
          bgColour,
          link,
        });

        $(this).append(progressBar);
      }
    });
  }

  // ProgressBar-storybook
  // %div.ethos-progress-bar{data:{
  //   percentage: 50,
  //   label: "MY Label",
  //   showlabeltext: "false",
  //   width: 520,
  // }}
};

$(document).on("ajaxComplete", function () {
  deferredInit();
});

// Call init function on page load
// Remove typeaheads, charts and datatables before cache
export default $(document)
  .on("turbo:load", function () {
    Init();
  })

  .on("turbo:before-visit", function () {
    // Add listeners for reloading page, maintaining scroll position if on same page
    // https://stackoverflow.com/questions/39679154/how-to-persist-scrolls-with-turbo
    let page = $("body").data("page");
    scrollPositions[page] = window.scrollY;
  })

  .on("turbo:before-cache", function () {
    // Collapse master search if present
    if ($("#master_search_typeahead").length !== 0) {
      $("#navbarSearchSm").removeClass("show");
      $("#master_search_typeahead").val("");
    }

    // Hide tooltips
    $('[data-toggle="tooltip"]').tooltip("hide");
    $('.tooltip[role="tooltip"]').remove();

    // Destroy typeaheads to avoid dup rendering on back button
    $(".select-page input").val("1");
    $(".twitter-typeahead input").typeahead("destroy");

    // Empty legends from below charts
    if ($(".legend").length !== 0) {
      $(".legend").empty();
    }

    // Remove google maps from BOM (window object)
    if (window.google !== undefined && window.google.maps !== undefined) {
      window.google.maps = undefined;
    }

    // Destroy datatables
    $(".dataTable.server-side tbody").remove(); // Avoid flickering/jumping on back button for tables that get data from server
    $(".dataTable").DataTable().destroy();

    // Remove modal backdrop; if don't remove before cache it appears twice on back button
    $(".modal-backdrop").remove();

    // Hide modals
    $(".modal").modal("hide");
  });
